import { session, setAuthHeader } from '@/api/session'

export default {
  getAllContracts (limit, offset, isActive) {
    let isActiveStr = isActive ? '&is_active=yes' : ''
    let url = `${process.env.VUE_APP_BACKEND_API_URL}commons/contract/?limit=${limit}&offset=${offset}${isActiveStr}`
    return session.get(url, setAuthHeader())
  }
}
